/**
 * safeNodeAt — nodeAt que nunca truena (T-080).
 *
 * ProseMirror lanza RangeError ("Position N outside of fragment") cuando la
 * posición quedó obsoleta porque el documento se encogió (borrado, undo, hoja
 * regenerada). Varios llamadores guardan posiciones "recordadas" (imagen
 * seleccionada, anclas de comentarios) y las consultan después — incluso en un
 * setInterval — así que una posición vieja convertía el editor en una tormenta
 * de excepciones sin catch. Aquí: fuera de rango -> null, igual que "no hay
 * nodo", y el llamador ya maneja null.
 */
export function safeNodeAt(doc, pos) {
  if (!doc || pos == null || pos < 0 || pos >= doc.content.size) return null;
  try {
    return doc.nodeAt(pos);
  } catch (e) {
    return null;
  }
}
